import Discount from 'components/discount/Discount';
import React from 'react';

const DiscountTab = () => {
    return (

        <Discount />

    );
};

export default DiscountTab;
